import * as R from "ramda"

export default R.pickBy(
  R.compose(
    R.not,
    R.isNil
  )
)
